import React from "react";
import MenuPortal from "./model";
import Select from "react-select";
import { useTranslation } from "react-i18next";

export const NormalMultiSelect = ({
  options,
  handleMultiSelect,
  placeholder = "Select",
  className,
  name,
  defaultValue = [],
  value = [],
  ismulti = true,
  target,
  isSearchable = false,
}) => {
  let { t } = useTranslation();
  return (
    <div className={`position-relative w-100 multi-select ${className}`}>
      <Select
        menuPortalTarget={target}
        placeholder={t(placeholder)}
        components={{ MenuPortal }}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        defaultValue={defaultValue}
        value={value}
        isMulti={ismulti}
        name={`${name}`}
        options={options}
        className="basic-multi-select"
        classNamePrefix="select"
        onChange={handleMultiSelect}
        isSearchable={isSearchable}
      />
    </div>
  );
};
